import { NextRouter, useRouter } from 'next/router';

import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { NavMenuLinks } from 'src/utils/constants/RouterConstants';

import { backButton } from './style';
import {
  MIXPANEL_BACK,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_TAB,
  MIXPANEL_TAB_NAME
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import {
  timeEvent,
  skipLoginEvent,
  skipRegistrationEvent,
  ctaEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

const trackMixpanelEvents = (location: string) => {
  // mixpanel skip login and registration event handling starts
  if (location.includes('/signin')) {
    timeEvent();
    skipLoginEvent();
  } else if (location.includes('/register')) {
    timeEvent();
    skipRegistrationEvent();
  }

  // mixpanel skip login and registration event handling ends
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_BACK;
  mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_TAB;
  mixpanelObject[MIXPANEL_TAB_NAME] = MIXPANEL_BACK;
  ctaEvent();
  // mixpanel cta event
};

const routeURLHandler = (pathname: string) => {
  const urlsList = [
    NavMenuLinks.LIVE_TV,
    NavMenuLinks.MOVIES,
    NavMenuLinks.TV_SHOWS,
    NavMenuLinks.WEBSERIES,
    NavMenuLinks.KIDS
  ];
  return urlsList.find((url) => pathname.includes(`${url}/`)) || '/';
};

//TODO: use router when pages are ready in webapp
const backButtonClickHandler = (router: NextRouter) => () => {
  const { pathname } = router;
  trackMixpanelEvents(pathname);
  window.location.href = routeURLHandler(pathname);
};

export const shouldShowBackButton = (path: string) => {
  const showButtonRegex =
    /(movies|tv-shows|live-tv|web-series|kids-shows|collections.*episodes|collections.*originals|schedule)/g;
  return showButtonRegex.test(path);
};

export const BackButton = () => {
  const router = useRouter();
  return (
    <span css={backButton} onClick={backButtonClickHandler(router)}></span>
  );
};
